module.exports = __webpack_public_path__ + "img/keyBuckle_2.1275762f.jpg";